// extracted by mini-css-extract-plugin
module.exports = {"root":"HostAvatar_root__ILJ-t","avatar":"HostAvatar_avatar__1NWi_"};